import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getDataFromPartnerAPI } from '../HandleAPICalls/actions';
import {
  setLoading,
  saveData,
} from './actions';
import MyOrganization from './component'

export class myOrganizationContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      corporateList: [],
    }
  }

  componentDidMount() {
    this.props.setLoading(true);
    const ls = localStorage.getItem('data');
    const token = ls ? JSON.parse(ls).accessToken : '';
    this.props.getDataFromPartnerAPI(
      '/corporate',
      'GET',
      {'Authorization': `Bearer ${token}`},
      response => {
        // this.setState({corporateList: response.data});
        this.props.saveData(response);
        this.props.setLoading(false);
        console.log('DATA COMING FROM CORPORATE DETAILS API', response);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log("tk--------",err);
      }
    );
  }


  render() {
    const corpList = this.props.myOrganization && this.props.myOrganization.corporateList
    return (
      <div>
        <MyOrganization corporateList={corpList}  />
      </div>
    )
  }
}

function mapStateToProps({ myOrganization }) {
  return {
    myOrganization
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromPartnerAPI,
    setLoading,
    saveData,
  })(myOrganizationContainer)
);




// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/container.jsx